import { Alert, Box, Container, Typography, Paper, Chip } from "@mui/material";
import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { getVariantOptionSurchargeForDisplay } from "../../common/util";

export default function CustomCatalog(props) {
  let location = useLocation();
  const { user } = useContext(UserContext);

  return (
    <Container maxWidth="md">
      <Box>
        <Box my={2}>
          <Alert severity="info">
            For any changes, please contact BakeStreet using the Online Chat option
          </Alert>
        </Box>
        <Box my={4}>
          <Typography variant="h1" gutterBottom>
            Custom Catalog
          </Typography>
          <Typography variant="body1" color="textSecondary">
            View items in your custom catalog, along with the variants and options for each item.
          </Typography>
        </Box>
      </Box>
      {Object.entries(user.config?.catalog)
        .sort(([, a], [, b]) => (a.name || "").localeCompare(b.name || ""))
        .map(([key, value]) => {
          return (
            <Box my={4} key={key}>
              <Paper elevation={0}>
                <Box p={2}>
                  <Typography variant="h5">{value.name}</Typography>
                  {value.variants &&
                    Object.entries(value.variants).map(([variantKey, variant]) => {
                      return (
                        <Box
                          py={2}
                          mt={2}
                          key={variant.name}
                          sx={{ borderTop: "1px solid #e0e0e0" }}
                        >
                          <Typography variant="h6" gutterBottom>
                            {variant.name}
                          </Typography>
                          <Box>
                            {variantKey === "size" ? (
                              <Box>
                                {variant.field.options.map((field) => (
                                  <Typography variant="body2">{field.name}</Typography>
                                ))}
                              </Box>
                            ) : (
                              <Box>
                                {variant.field.options
                                  .sort((opt1, opt2) => opt1.name.localeCompare(opt2.name))
                                  .map((option) => {
                                    let surcharge = getVariantOptionSurchargeForDisplay(option);
                                    if (option.override) {
                                      surcharge = "Priced by Size";
                                    }
                                    return (
                                      <Chip
                                        size="small"
                                        label={`${option.name}${surcharge ? ` | ${surcharge}` : ""}`}
                                      />
                                    );
                                  })}
                              </Box>
                            )}
                          </Box>
                        </Box>
                      );
                    })}
                </Box>
              </Paper>
            </Box>
          );
        })}
    </Container>
  );
}
